import * as React from 'react';
import { DropdownType, NavigationItemModel } from '../../Header.types';
import ProductDropdown from '../ProductDropdown/ProductDropdown';
import SystemDropdown from '../SystemDropdown/SystemDropdown';
import TradeDropdown from '../TradeDropdown/TradeDropdown';
import S from './DesktopNavigationDropdown.styles';

export type DesktopNavigationLinkProps = {
  type?: DropdownType;
  sectionTitle?: string;
  items: NavigationItemModel[];
  visible: boolean;
  productsVariant?: 'A' | 'B';
  translations: Record<string, string>;
};

const DesktopNavigationDropdown: React.FC<DesktopNavigationLinkProps> = ({
  type,
  sectionTitle,
  items,
  visible,
  productsVariant,
  translations,
}) => {
  return (
    <S.Container aria-current={visible} data-products-variant={getVariant()} data-narrow-width={isNarrowWidth()}>
      <S.Inner>{renderDropdown()}</S.Inner>
    </S.Container>
  );

  /**
   * @description Render the dropdown based on the type
   */
  function renderDropdown(): React.ReactNode {
    switch (type) {
      case DropdownType.Product:
        return (
          <ProductDropdown
            items={items}
            visible={visible}
            productsVariant={productsVariant}
            translations={translations}
          />
        );
      case DropdownType.System:
        return <SystemDropdown sectionTitle={sectionTitle} items={items} translations={translations} />;
      case DropdownType.Trade:
        return <TradeDropdown items={items} visible={visible} translations={translations} />;
      default:
        return null;
    }
  }

  /**
   * @description Get the variant for the dropdown based on the dropdown type
   * @returns the variant for the dropdown
   */
  function getVariant(): 'A' | 'B' | undefined {
    if (type === DropdownType.Trade) {
      return 'B';
    }

    if (type === DropdownType.Product) {
      return productsVariant;
    }

    return undefined;
  }

  /**
   * @description Check if the dropdown should be narrow width based on the dropdown type
   * @returns whether the dropdown should be narrow width
   */
  function isNarrowWidth(): boolean {
    if (productsVariant === 'A' && type === DropdownType.Product) {
      return true;
    }

    return false;
  }
};

export default DesktopNavigationDropdown;
